<template>
  <div>

    <section class="content">
      <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-cyan" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Verifikasi Instrumen KS/Bendahara</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nama Responden</th>
                            <th style="width: 20%">Jabatan</th>
                            <th style="width: 30%">Sekolah</th>
                            <th style="width: 10%">Status</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td class="text-center" :style="cekStatus(data.status)">{{index+1}}.</td>
                            <td>{{data.profile_id.profile.nama}}</td>
                            <td>{{data.profile_id.profile.jabatan}}</td>
                            <td>{{data.sekolah.type}} {{data.sekolah.status}} {{data.sekolah.sekolah}}</td>
                            <td>{{data.status}}</td>
                            <td class="text-center" >
                              <button class="btn bg-light-blue btn-xs waves-effect" @click="viewData(data.data_id)" title="Lihat Data" data-toggle="modal" data-target="#m_lihat_data">
                                  <i class="material-icons" >search</i>
                              </button>
                              <button class="btn bg-light-green btn-xs waves-effect" @click="viewId(data.data_id)" title="Setujui Data" data-toggle="modal" data-target="#m_setujui_data">
                                  <i class="material-icons" >done</i>
                              </button>
                              <button class="btn bg-red btn-xs waves-effect" @click="viewId(data.data_id)" title="Kembalikan Data" data-toggle="modal" data-target="#m_kembalikan_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>

                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_setujui_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan penilaian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="setujuiData" class="btn btn-success waves-effect">SETUJUI</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_kembalikan_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-deep-orange">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan pengembalian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="kembalikanData" class="btn bg-deep-orange waves-effect">KEMBALIKAN</button>
                                    <button type="button" class="btn bg-red waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                                </div>
                                <div class="modal-body">


                                  <div class="table-responsive" >
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-info" :style="cekStatus">
                                            <th colspan="6">{{saran}}</th>
                                          </tr>
                                          <tr class="bg-grey">
                                              <th class="text-center" rowspan="2" style="width: 5%">No.</th>
                                              <th class="text-center" rowspan="2" style="width: 20%">Uraian</th>
                                              <th class="text-center" rowspan="2" style="width: 30%">Metode Pengukuran</th>
                                              <th class="text-center" colspan="2" style="width: 20%">Jawaban Dari Metode Pengukuran</th>
                                              <th class="text-center" rowspan="2" style="width: 25%">Keterangan (Tuliskan hasil metode pengukuran berdasarkan jawaban yang dipilih ("Ya" atau "Tidak")</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th class="text-center" style="width: 10%">YA</th>
                                            <th class="text-center" style="width: 10%">TIDAK</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                              <td class="text-center">1.</td>
                                              <td>Sekolah telah menyusun RKAS  2017 </td>
                                              <td>Cek dokumen di sekolah</td>
                                              <td class="text-center"><span v-if="soal_1=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_1=='tidak'">v</span></td>
                                              <td>{{ket_1}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">2.</td>
                                              <td>Sekolah melibatkan  dewan guru dan komite sekolah dalam penyusunan rencana penggunaan dana BOS yang ditandai dengan berita acara </td>
                                              <td>Cek dokumen berita acara rapat dan cross check ke komite sekolah dan guru melalui wawancara</td>
                                              <td class="text-center"><span v-if="soal_2=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_2=='tidak'">v</span></td>
                                              <td>{{ket_2}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">3.</td>
                                              <td>Sekolah menginformasikan dana BOS yang diterima dan rencana penggunaan dana BOS di papan pengumuman sekolah</td>
                                              <td>Cek di papan pengumuman</td>
                                              <td class="text-center"><span v-if="soal_3=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_3=='tidak'">v</span></td>
                                              <td>{{ket_3}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">4.</td>
                                              <td>Telah memiliki SK Tim Manajemen BOS Sekolah sesuai Juklak BOS</td>
                                              <td>Cek dokumen SK</td>
                                              <td class="text-center"><span v-if="soal_4=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_4=='tidak'">v</span></td>
                                              <td>{{ket_4}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">5.</td>
                                              <td>Pengambilan dana BOS dilakukan oleh Bendahara Sekolah dan disetujui oleh Kepala Sekolah</td>
                                              <td>Cek buku tabungan</td>
                                              <td class="text-center"><span v-if="soal_5=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_5=='tidak'">v</span></td>
                                              <td>{{ket_5}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">6.</td>
                                              <td>Apakah dana BOS yang diterima sesuai dengan jumlah siswa</td>
                                              <td>Cek data siswa (Jika Tidak sesuai tuliskan jumlah siswa yang ada)</td>
                                              <td class="text-center"><span v-if="soal_6=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_6=='tidak'">v</span></td>
                                              <td>{{ket_6}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">7.</td>
                                              <td>Penggunaan dana BOS Triwulan I sesuai dengan alokasi RKAS BOS Tri wulan II</td>
                                              <td>Cek RKAS Triwulan 2 Cek dokumen pertanggungjawaban (SPJ)</td>
                                              <td class="text-center"><span v-if="soal_7=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_7=='tidak'">v</span></td>
                                              <td>{{ket_7}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">8.</td>
                                              <td>Jumlah dana yang dicairkan disesuaikan dengan kebutuhan sekolah (sesuai rencana pengeluaran sekolah)</td>
                                              <td>Cek buku tabungan dan RKAS</td>
                                              <td class="text-center"><span v-if="soal_8=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_8=='tidak'">v</span></td>
                                              <td>{{ket_8}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">9.</td>
                                              <td>Telah menyusun laporan realisasi penggunaan dana BOS triwulan 2 Tahun 2017 melalui format BOS - K7</td>
                                              <td>Cek laporan Format BOS-K7</td>
                                              <td class="text-center"><span v-if="soal_9=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_9=='tidak'">v</span></td>
                                              <td>{{ket_9}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">10.</td>
                                              <td>Masih adakah pungutan kepada orang tua siswa (bebas pungutan) bagi seluruh siswa <b>(untuk sekolah negeri)</b> dan Bebas pungutan bagi siswa miskin <b>(untuk sekolah swasta)</b></td>
                                              <td>Cek dengan orang tua siswa/ komite sekolah</td>
                                              <td class="text-center"><span v-if="soal_10=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_10=='tidak'">v</span></td>
                                              <td>{{ket_10}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">11.</td>
                                              <td>Gedung sekolah terawat dengan baik</td>
                                              <td>Lakukan pengamatan ke lingkungan sekolah</td>
                                              <td class="text-center"><span v-if="soal_11=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_11=='tidak'">v</span></td>
                                              <td>{{ket_11}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">12.</td>
                                              <td>WC sekolah cukup dan terawat</td>
                                              <td>Lakukan pengamatan ke WC sekolah, Hitung jumlah WC dan kondisinya</td>
                                              <td class="text-center"><span v-if="soal_12=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_12=='tidak'">v</span></td>
                                              <td>{{ket_12}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">13.</td>
                                              <td>Air bersih di sekolah tersedia cukup dan lancar</td>
                                              <td>Lakukan pengamatan ke sumber air dan cek kran air</td>
                                              <td class="text-center"><span v-if="soal_13=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_13=='tidak'">v</span></td>
                                              <td>{{ket_13}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">14.</td>
                                              <td>Kegiatan pembelajaran dan ekstrakurikuler berjalan lancar</td>
                                              <td>cek dengan guru-guru</td>
                                              <td class="text-center"><span v-if="soal_14=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_14=='tidak'">v</span></td>
                                              <td>{{ket_14}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">15.</td>
                                              <td>Lingkungan / taman sekolah tertata dengan rapi, rimbun dan bersih</td>
                                              <td>Lakukan pengamatan ke taman dan lingkungan sekolah</td>
                                              <td class="text-center"><span v-if="soal_15=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_15=='tidak'">v</span></td>
                                              <td>{{ket_15}}</td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">16.</td>
                                              <td>Apakah ada masaalah terhadap penerimaan dana BOS (seperti pungutan liar, terlambat cair dll)</td>
                                              <td>Jika "Ya" Tuliskan masaalahnya pada kolom Keterangan</td>
                                              <td class="text-center"><span v-if="soal_16=='ya'">v</span></td>
                                              <td class="text-center"><span v-if="soal_16=='tidak'">v</span></td>
                                              <td>{{ket_16}}</td>
                                          </tr>

                                        </tbody>
                                    </table>
                                </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>




      </div>
    </section>
  </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/ver_instrumen_ks_bendahara/';


export default {
  name: "monev_ver_instrumen_komite_sekolah",
  data() {
    return {
      data_id : '',
      soal_1 : '', ket_1 : '',
      soal_2 : '', ket_2 : '',
      soal_3 : '', ket_3 : '',
      soal_4 : '', ket_4 : '',
      soal_5 : '', ket_5 : '',
      soal_6 : '', ket_6 : '',
      soal_7 : '', ket_7 : '',
      soal_8 : '', ket_8 : '',
      soal_9 : '', ket_9 : '',
      soal_10 : '', ket_10 : '',
      soal_11 : '', ket_11 : '',
      soal_12 : '', ket_12 : '',
      soal_13 : '', ket_13 : '',
      soal_14 : '', ket_14 : '',
      soal_15 : '', ket_15 : '',
      soal_16 : '', ket_16 : '',

      saran : '',

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    viewId : function(data_id){
      this.data_id = data_id
    },

    setujuiData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'diterima',

        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });
    },

    kembalikanData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'dikembalikan',
        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });

    },

    viewData : function(data_cari){
      fetch(ADD_URL+'view_one', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: data_cari,
        })
      }).then(res => res.json())
        .then((data_res) => {

          // console.log(data_res.data);


          if (data_res.data == null) {
            this.counter = true
          } else {
            this.counter = false
          }

          this.soal_1 = data_res.data.soal_1; this.ket_1 = data_res.data.ket_1;
          this.soal_2 = data_res.data.soal_2; this.ket_2 = data_res.data.ket_2;
          this.soal_3 = data_res.data.soal_3; this.ket_3 = data_res.data.ket_3;
          this.soal_4 = data_res.data.soal_4; this.ket_4 = data_res.data.ket_4;
          this.soal_5 = data_res.data.soal_5; this.ket_5 = data_res.data.ket_5;
          this.soal_6 = data_res.data.soal_6; this.ket_6 = data_res.data.ket_6;
          this.soal_7 = data_res.data.soal_7; this.ket_7 = data_res.data.ket_7;
          this.soal_8 = data_res.data.soal_8; this.ket_8 = data_res.data.ket_8;
          this.soal_9 = data_res.data.soal_9; this.ket_9 = data_res.data.ket_9;
          this.soal_10 = data_res.data.soal_10; this.ket_10 = data_res.data.ket_10;
          this.soal_11 = data_res.data.soal_11; this.ket_11 = data_res.data.ket_11;
          this.soal_12 = data_res.data.soal_12; this.ket_12 = data_res.data.ket_12;
          this.soal_13 = data_res.data.soal_13; this.ket_13 = data_res.data.ket_13;
          this.soal_14 = data_res.data.soal_14; this.ket_14 = data_res.data.ket_14;
          this.soal_15 = data_res.data.soal_15; this.ket_15 = data_res.data.ket_15;
          this.soal_16 = data_res.data.soal_16; this.ket_16 = data_res.data.ket_16;
          this.saran = data_res.data.saran;

        })
    },


    cekStatus : function(data){
      if(data == 'diterima'){
        return {background : '#e4ffc4'}
      }
      else if (data == 'dikembalikan') {
        return {background : '#ffcece'}
      }
    },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================



  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
  },
  computed: {

    ket_16_selesaix : function(){
      return parseFloat(this.ket_16_selesai_01)+ parseFloat(this.ket_16_selesai_02) + parseFloat(this.ket_16_selesai_03) + parseFloat(this.ket_16_selesai_04)
    },
    ket_16_belumx : function(){
      return parseFloat(this.ket_16_belum_01)+ parseFloat(this.ket_16_belum_02) + parseFloat(this.ket_16_belum_03) + parseFloat(this.ket_16_belum_04)
    },
    ket_16_masukx : function(){
      return parseFloat(this.ket_16_masuk_01)+ parseFloat(this.ket_16_masuk_02) + parseFloat(this.ket_16_masuk_03) + parseFloat(this.ket_16_masuk_04)
    },
  },
};
</script>

